import { ProfileInstitutions } from '@/resources/ProfileInstitutions';

export function formatInstitutionLine(institution: ProfileInstitutions) {
  const order = [institution.name, institution.department, institution.city, institution.country].filter((i) => i);
  const location = order.join(', ');

  if (institution.roleName) {
    return `${institution.roleName} @ ${location}`;
  }
  return location;
}
